/**
 * @file useLastLogInDate.ts
 * @description
 * -----------------------------------------------------
 * Hook personalizado para obtener la fecha del último inicio de sesión
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-06-02
 * @author DLTCode
 * @author Nacho Moya
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { useMemo } from "react";
import { useFormatDateTimeCallback } from "../../../hooks/useFormatDate";
import { useSession } from "@/features/auth";

/**
 * Hook personalizado para obtener la fecha del último inicio de sesión del usuario.
 * Utiliza el contexto de sesión de NextAuth para acceder a los datos del usuario.
 * @return {string | undefined} La fecha del último inicio de sesión formateada, o `undefined` si no hay datos disponibles.
 */
export function useLastLogInDate(): string | undefined {
  const session = useSession();
  const formatDateTimeCallback = useFormatDateTimeCallback();

  const lastLogIn = useMemo(() => {
    const date = session.data?.lastLogin || undefined;
    return date ? formatDateTimeCallback(date) : undefined;
  }, [session.data, formatDateTimeCallback]);

  return lastLogIn;
}
